import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { ClassificationBignumberCard } from "./ClassificationBignumberCard";
import { GeneralDashboardAnmPreview } from "../api/generalDashboard/generalDashboard.types";
import {
  formatClassificationBandLabel,
  formatGoDisplayValue,
  mapGoLevelToClassificationLevel,
} from "../utils/formatClassificationBandLabel";
import type { GoClassificationLevel } from "@shared/utils";

interface GeneralAnmClassificationCardProps {
  data: GeneralDashboardAnmPreview | null;
  onMenuClick: () => void;
}

export const GeneralAnmClassificationCard: React.FC<GeneralAnmClassificationCardProps> = ({
  data,
  onMenuClick,
}) => {
  const { translate } = useLocalization();

  const goLevel = data?.go?.gopClass
    ? (data.go.gopClass.toLowerCase() as GoClassificationLevel)
    : undefined;

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.anmClassification.title")}
      onMenuClick={onMenuClick}
    >
      <div className="general-dashboard-bignumber-row">
          <ClassificationBignumberCard
            label={translate("general.dashboard.anmClassification.dpa")}
            displayValue={formatClassificationBandLabel(
              translate,
              data?.dpa?.classificationLevel,
            )}
            level={data?.dpa?.classificationLevel}
          />
          <ClassificationBignumberCard
            label={translate("general.dashboard.anmClassification.cri")}
            displayValue={formatClassificationBandLabel(
              translate,
              data?.cri?.classificationLevel,
            )}
            level={data?.cri?.classificationLevel}
          />
          <ClassificationBignumberCard
            label={translate("general.dashboard.anmClassification.go")}
            displayValue={formatGoDisplayValue(data?.go?.gopClass)}
            level={mapGoLevelToClassificationLevel(
              data?.go?.gopClass,
              data?.go?.classificationLevel,
            )}
            goLevel={goLevel}
          />
      </div>
    </GeneralDashboardCard>
  );
};
